// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application-history-content {
    width: 100%;
    overflow-x: auto;
}

.section-heading {
    font-size: 13px;
    font-weight: 700;
    color: #0066B2;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 10px;
    margin-top: 4px;
}

.assignment-history-heading {
    display: flex;
    align-items: center;
}

.section-divider {
    border-top: 1px solid #e0e0e0;
    margin: 18px 0;
}

/* AI History table */
.ai-history-section {
    margin-bottom: 4px;
}

.ai-history-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.ai-history-table th {
    padding: 7px 10px;
    text-align: left;
    font-weight: 700;
    color: #555;
    background: #f5f5f5;
    border-bottom: 2px solid #e0e0e0;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.ai-history-table td {
    padding: 8px 10px;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
    color: #333;
    font-size: 12px;
}

.ai-history-table tbody tr:last-child td {
    border-bottom: none;
}

.ai-status-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
}

.badge-completed {
    background: #d4edda;
    color: #155724;
}

.badge-failed {
    background: #f8d7da;
    color: #721c24;
}

.badge-running {
    background: #d1ecf1;
    color: #0c5460;
}

.requested-by {
    font-size: 12px;
    color: #666;
}

.btn-view-ai {
    font-size: 11px;
    font-weight: 600;
    color: #0066B2;
    background: none;
    border: 1px solid #0066B2;
    border-radius: 4px;
    padding: 2px 10px;
    cursor: pointer;
    transition: background 0.12s, color 0.12s;
}

.btn-view-ai:hover {
    background: #0066B2;
    color: #fff;
}

.app-name {
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e0e0e0;
}

.no-data {
    padding: 20px;
    text-align: center;
    color: #666;
    font-style: italic;
}

/* Assignment History table - matching AI History design */
.assignment-history-section {
    margin-bottom: 4px;
}

.assignment-history-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.assignment-history-table th {
    padding: 7px 10px;
    text-align: left;
    font-weight: 700;
    color: #555;
    background: #f5f5f5;
    border-bottom: 2px solid #e0e0e0;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.assignment-history-table td {
    padding: 8px 10px;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
    color: #333;
    font-size: 12px;
}

.assignment-history-table tbody tr:last-child td {
    border-bottom: none;
}

.assignment-history-table tbody tr:nth-child(even) {
    background-color: white;
}

.text-center {
    text-align: center;
    padding: 20px;
}

.alert {
    padding: 12px;
    margin-bottom: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
}

.alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/applications/application-history/application-history-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,sBAAsB;IACtB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA,0DAA0D;AAC1D;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,sBAAsB;IACtB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB","sourcesContent":[".application-history-content {\n    width: 100%;\n    overflow-x: auto;\n}\n\n.section-heading {\n    font-size: 13px;\n    font-weight: 700;\n    color: #0066B2;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    margin-bottom: 10px;\n    margin-top: 4px;\n}\n\n.assignment-history-heading {\n    display: flex;\n    align-items: center;\n}\n\n.section-divider {\n    border-top: 1px solid #e0e0e0;\n    margin: 18px 0;\n}\n\n/* AI History table */\n.ai-history-section {\n    margin-bottom: 4px;\n}\n\n.ai-history-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n}\n\n.ai-history-table th {\n    padding: 7px 10px;\n    text-align: left;\n    font-weight: 700;\n    color: #555;\n    background: #f5f5f5;\n    border-bottom: 2px solid #e0e0e0;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.ai-history-table td {\n    padding: 8px 10px;\n    border-bottom: 1px solid #f0f0f0;\n    vertical-align: middle;\n    color: #333;\n    font-size: 12px;\n}\n\n.ai-history-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.ai-status-badge {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 10px;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n\n.badge-completed {\n    background: #d4edda;\n    color: #155724;\n}\n\n.badge-failed {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.badge-running {\n    background: #d1ecf1;\n    color: #0c5460;\n}\n\n.requested-by {\n    font-size: 12px;\n    color: #666;\n}\n\n.btn-view-ai {\n    font-size: 11px;\n    font-weight: 600;\n    color: #0066B2;\n    background: none;\n    border: 1px solid #0066B2;\n    border-radius: 4px;\n    padding: 2px 10px;\n    cursor: pointer;\n    transition: background 0.12s, color 0.12s;\n}\n\n.btn-view-ai:hover {\n    background: #0066B2;\n    color: #fff;\n}\n\n.app-name {\n    margin-bottom: 15px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.no-data {\n    padding: 20px;\n    text-align: center;\n    color: #666;\n    font-style: italic;\n}\n\n/* Assignment History table - matching AI History design */\n.assignment-history-section {\n    margin-bottom: 4px;\n}\n\n.assignment-history-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n}\n\n.assignment-history-table th {\n    padding: 7px 10px;\n    text-align: left;\n    font-weight: 700;\n    color: #555;\n    background: #f5f5f5;\n    border-bottom: 2px solid #e0e0e0;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.assignment-history-table td {\n    padding: 8px 10px;\n    border-bottom: 1px solid #f0f0f0;\n    vertical-align: middle;\n    color: #333;\n    font-size: 12px;\n}\n\n.assignment-history-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.assignment-history-table tbody tr:nth-child(even) {\n    background-color: white;\n}\n\n.text-center {\n    text-align: center;\n    padding: 20px;\n}\n\n.alert {\n    padding: 12px;\n    margin-bottom: 15px;\n    border: 1px solid transparent;\n    border-radius: 4px;\n}\n\n.alert-danger {\n    color: #721c24;\n    background-color: #f8d7da;\n    border-color: #f5c6cb;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
